import {
    AccountCircle,
    Dashboard as DashboardIcon,
    Analytics as MonitoringIcon,
    ExitToApp,
    QuestionAnswer as FAQIcon,
    WhatsApp as WhatsAppIcon,
} from '@mui/icons-material';
import {
    AppBar,
    IconButton,
    Menu,
    MenuItem,
    Toolbar,
    Typography,
    Button,
} from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const MainAppBar = () => {
    const { logout, user } = useAuth();
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = () => {
        logout();
        navigate('/login');
        handleClose();
    };

    // Optionnel: si vous voulez un lien vers le profil ou d'autres actions
    // const goToProfile = () => {
    //     navigate('/profile'); // Assurez-vous que cette route existe
    //     handleClose();
    // };

    const handleDashboardClick = () => {
        navigate('/dashboard');
    };

    const handleMonitoringClick = () => {
        navigate('/monitoring');
    };

    return (
        <AppBar position="static" elevation={1} sx={{ backgroundColor: '#007bff' }}>
            <Toolbar>
                <IconButton
                    color="inherit"
                    onClick={handleDashboardClick}
                    sx={{ mr: 1, p: 1 }}
                    aria-label="Retour au dashboard principal"
                >
                    <DashboardIcon />
                </IconButton>
                <Typography
                    variant="h6"
                    component="div"
                    sx={{
                        flexGrow: 1,
                        cursor: 'pointer',
                        '&:hover': {
                            opacity: 0.8
                        }
                    }}
                    onClick={handleDashboardClick}
                >
                    DigitalCloud360 Dashboard
                </Typography>
                
                {/* Navigation Buttons */}
                <Button
                    color="inherit"
                    startIcon={<MonitoringIcon />}
                    onClick={handleMonitoringClick}
                    sx={{ mr: 2 }}
                >
                    Monitoring
                </Button>
                
                {user && (
                    <div>
                        <Typography component="span" sx={{ mr: 2 }}>
                            {user.first_name || user.email}
                        </Typography>
                        <IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleMenu}
                            color="inherit"
                        >
                            <AccountCircle />
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorEl}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                        >
                            {/* <MenuItem onClick={goToProfile}>Mon Profil</MenuItem> */}
                            <MenuItem onClick={handleLogout}>
                                <ExitToApp sx={{ mr: 1 }} />
                                Déconnexion
                            </MenuItem>
                        </Menu>
                    </div>
                )}
            </Toolbar>
        </AppBar>
    );
};

export default MainAppBar;
